import { Typography } from '@euler/app/components/typography';
import { Center } from '@euler/components/Center';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { SafeHaptics } from '@euler/utils';
import { usePersistFn } from '@euler/utils/hooks';
import * as Clipboard from 'expo-clipboard';
import { memo } from 'react';
import { StyleProp, TextStyle } from 'react-native';
import Toast from 'react-native-root-toast';

export const OrderSummaryInlineInfoCell = memo(
  ({
    label,
    content,
    contentStyle,
    copy,
    onPress,
  }: {
    label: string;
    content: string;
    contentStyle?: StyleProp<TextStyle>;
    copy?: string | boolean;
    onPress?: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const handlePress = usePersistFn(async () => {
      onPress?.();
      if (copy) {
        await Clipboard.setStringAsync(
          typeof copy === 'string' ? copy : content,
        );
        Toast.show('已复制', {
          duration: 500,
          position: Toast.positions.CENTER,
        });
        SafeHaptics.impact();
      }
    });
    return (
      <Center.Touchable
        activeOpacity={!onPress && !copy ? 1 : undefined}
        onPress={handlePress}
      >
        <Typography.Text
          light
          color="#999"
          size={rpx(12)}
          lineHeight={rpx(16)}
          mb={rpx(2)}
        >
          {label}
        </Typography.Text>
        <Typography.Text
          regular
          color="#333"
          size={rpx(13)}
          lineHeight={rpx(20)}
          style={contentStyle}
        >
          {content}
        </Typography.Text>
      </Center.Touchable>
    );
  },
);
